/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const WebApiModelsEnumerationTypesInvoiceStatus = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;
export type WebApiModelsEnumerationTypesInvoiceStatus = typeof WebApiModelsEnumerationTypesInvoiceStatus[keyof typeof WebApiModelsEnumerationTypesInvoiceStatus];


export function WebApiModelsEnumerationTypesInvoiceStatusFromJSON(json: any): WebApiModelsEnumerationTypesInvoiceStatus {
    return WebApiModelsEnumerationTypesInvoiceStatusFromJSONTyped(json, false);
}

export function WebApiModelsEnumerationTypesInvoiceStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiModelsEnumerationTypesInvoiceStatus {
    return json as WebApiModelsEnumerationTypesInvoiceStatus;
}

export function WebApiModelsEnumerationTypesInvoiceStatusToJSON(value?: WebApiModelsEnumerationTypesInvoiceStatus | null): any {
    return value as any;
}

